'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSendNewOfficeHoursMessage = undefined;

var _hasBotMessages = require('./hasBotMessages');

var _hasOfficeHoursMessageFromCurrentSession = require('./hasOfficeHoursMessageFromCurrentSession');

var _enoughTimeHasPassedForNewAutomatedChatMessage = require('./enoughTimeHasPassedForNewAutomatedChatMessage');

var canSendNewOfficeHoursMessage = exports.canSendNewOfficeHoursMessage = function canSendNewOfficeHoursMessage(threadHistory) {
  return !(0, _hasBotMessages.hasBotMessages)(threadHistory) && (!(0, _hasOfficeHoursMessageFromCurrentSession.hasOfficeHoursMessageFromCurrentSession)(threadHistory) || (0, _enoughTimeHasPassedForNewAutomatedChatMessage.enoughTimeHasPassedForNewAutomatedChatMessage)(threadHistory));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/canSendNewOfficeHoursMessage.js
// module id = 582
// module chunks = 2 3